<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    :fill="fillColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16C10.2333 16 12.125 15.225 13.675 13.675C15.225 12.125 16 10.2333 16 8C16 5.76667 15.225 3.875 13.675 2.325C12.125 0.775 10.2333 0 8 0C6.85 0 5.75 0.2375 4.7 0.7125C3.65 1.1875 2.75 1.86667 2 2.75V1C2 0.716667 1.90417 0.479167 1.7125 0.2875C1.52083 0.0958333 1.28333 0 1 0C0.716666 0 0.479166 0.0958333 0.287499 0.2875C0.0958328 0.479167 0 0.716667 0 1V6C0 6.28333 0.0958328 6.52083 0.287499 6.7125C0.479166 6.90417 0.716666 7 1 7H6C6.28333 7 6.52083 6.90417 6.7125 6.7125C6.90417 6.52083 7 6.28333 7 6C7 5.71667 6.90417 5.47917 6.7125 5.2875C6.52083 5.09583 6.28333 5 6 5H2.8C3.33333 4.06667 4.0625 3.33333 4.9875 2.8C5.9125 2.26667 6.91667 2 8 2C9.66667 2 11.0833 2.58333 12.25 3.75C13.4167 4.91667 14 6.33333 14 8C14 9.66667 13.4167 11.0833 12.25 12.25C11.0833 13.4167 9.66667 14 8 14C6.86667 14 5.82917 13.7125 4.8875 13.1375C3.94583 12.5625 3.21667 11.7917 2.7 10.825C2.56667 10.5917 2.37917 10.4292 2.1375 10.3375C1.89583 10.2458 1.65 10.2417 1.4 10.325C1.13333 10.4083 0.941667 10.5833 0.825 10.85C0.708333 11.1167 0.716666 11.3667 0.849999 11.6C1.53333 12.9333 2.50833 14 3.775 14.8C5.04167 15.6 6.45 16 8 16Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    fillColor: {
      type: String,
      default: '#6D6D6D'
    },
    width: {
      type: [String, Number],
      default: 20
    },
    height: {
      type: [String, Number],
      default: 20
    }
  }
}
</script>
